export const LEAD_FORM_T = {
  en: {
    name: 'Full name *', company: 'Company / organisation', companyPh: 'Optional', namePh: 'Your full name',
    phone: 'Mobile number *', email: 'Email address *', emailPh: 'your@email.com',
    message: 'Tell us about the opportunity', messagePh: 'Share your requirement, scale and any timelines...',
    submit: 'Submit Enquiry', submitting: 'Submitting...',
    successTitle: 'Enquiry submitted', successBody: 'Thank you. A specialist will review your enquiry and follow up with the appropriate next steps.',
    noDetails: 'No additional details provided.',
  },
  ar: {
    name: 'الاسم الكامل *', company: 'الشركة / المؤسسة', companyPh: 'اختياري', namePh: 'اسمك الكامل',
    phone: 'رقم الجوال *', email: 'البريد الإلكتروني *', emailPh: 'your@email.com',
    message: 'أخبرنا عن الفرصة', messagePh: 'شارك متطلباتك والنطاق وأي جداول زمنية...',
    submit: 'إرسال الطلب', submitting: 'جارٍ الإرسال...',
    successTitle: 'تم إرسال الطلب', successBody: 'شكراً لك. سيقوم أحد المختصين بمراجعة طلبك ومتابعته بالخطوات المناسبة.',
    noDetails: 'لم تُقدَّم تفاصيل إضافية.',
  },
};
